import React from "react";

export const Error = ({ status, msg }) => {
  return (
    <div>
      <h1>Error occured while processing request</h1>
      <h1>{status}</h1>
      <h3>{msg}</h3>
    </div>
  );
};
